import MalnutritionAPIContext from ".";
import { malnutritionUseMocks } from "../../api/malnutrition/mocks";
import {
  useMalnutritionRiskQuery,
  usePatientWeightsQuery,
} from "../../api/malnutrition/queries";
import { useConfigurationQuery } from "../../api/queries";

import type { FC, ReactNode } from "react";

interface MalnutritionAPIContextProviderProps {
  emrPatientID: string;
  emrHospitalID: string;
  children?: ReactNode;
}

const MalnutritionAPIContextProvider: FC<
  MalnutritionAPIContextProviderProps
> = ({ emrPatientID, emrHospitalID, children }) => {
  const riskAssessmentQuery = useMalnutritionRiskQuery(
    emrPatientID,
    emrHospitalID
  );
  const weightsQuery = usePatientWeightsQuery(emrPatientID, emrHospitalID);
  // Mock mode runs without a backend, so it skips this and shows the MRN.
  const configurationQuery = useConfigurationQuery(!malnutritionUseMocks());

  return (
    <MalnutritionAPIContext.Provider
      value={{
        emrPatientID,
        emrHospitalID,
        riskAssessmentQuery,
        weightsQuery,
        configurationQuery,
      }}
    >
      {children}
    </MalnutritionAPIContext.Provider>
  );
};

export default MalnutritionAPIContextProvider;
